export const SIGNUP = '/signup';
export const SIGNIN = '/signin';
export const MAINROOM = '/main';
export const CALL = '/call';
export const CONTACT_CALL = '/contactcall';